"use client";

import Link from 'next/link'
import { useEffect } from 'react'

export const About = () => {
  useEffect(() => {
    console.log('OUR MISSION')
  }, [])

  return (
    <>
      <div className="max-w-4xl">
        <h1 className="block text-5xl font-medium mb-4">OUR MISSION</h1>
        <div className="text-lg font-sans">
          <div>
            <p>
              Canary Mission documents individuals and organizations that promote hatred of the USA,
              Israel and Jews on North American college campuses and beyond. Canary Mission
              investigates hatred across the entire political spectrum, including the far right, far
              left and anti-Israel activists.
            </p>
            <br />
            <p>
              Canary Mission is motivated by a desire to combat the rise in anti-Semitism on college
              campuses. We pursue our mission by presenting the words and deeds of individuals and
              organizations that engage in anti-Semitism, racism and bigotry on the far right, far
              left and among the array of organizations that comprise the anti-Semitic{' '}
              <Link
                className="text-colorLink no-underline"
                href={'/organization/Boycott_Divestment_Sanctions'}
              >
                Boycott, Divestment, Sanctions (BDS)
              </Link>{' '}
              movement.
            </p>
            <br />
            <p>
              Canary Mission gathers content from publicly available sources. Additionally, we
              collect and validate materials{' '}
              <Link className="text-colorLink no-underline" href={'/contact_us'}>
                submitted
              </Link>{' '}
              privately through our website. We aggregate this information into a concise and easily
              searchable format, providing free access to the general public.
            </p>
            <br />
            <p>
              Before publication, all content is verified, meeting our high standards of accuracy
              and authenticity.
            </p>
            <br />
            <p>
              When published content is based on validated information submitted privately, a note
              indicating this is placed on the page.
            </p>
            <br />
            <p>
              The addition of individuals to our database is governed by our{' '}
              <Link className="text-colorLink no-underline" href={'/ethics_policy'}>
                Ethics Policy
              </Link>{' '}
              .
            </p>
            <br />
            <p>
              Individuals who believe that they should be removed from the Canary Mission website
              are encouraged to be in touch with us and may become an{' '}
              <Link className="text-colorLink no-underline" href={'/ex-canary'}>
                Ex-Canary
              </Link>
              .
            </p>
            <br />
            <p>
              By shining a light on hate groups and their members, the public is better informed
              about bigotry on their campuses and in their communities. Canary Mission believes that
              we all have the right to know if an individual has been affiliated with movements that
              routinely engage in anti-Semitic rhetoric and actions, promote hatred of Jews and seek
              the destruction of Israel.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
export default About
